import InfoCircleFilled from '../src/InfoCircleFilled';
export default InfoCircleFilled;
